import React, { Suspense, lazy } from "react";
import { LoadingTile } from "./elements/LoadingTile/LoadingTile";

const DynamicHeroContainer = lazy(() => import("./blocks/DynamicHero"));
const FeaturedMediaContainer = lazy(() => import("./blocks/FeaturedMedia"));
const VideoPlayerContainer = lazy(() => import("./blocks/VideoPlayer"));
const FormattedRichTextContainer = lazy(
  () => import("./blocks/FormattedRichText")
);
const CTABarContainer = lazy(() => import("./blocks/CTABar"));
const EmbedContainer = lazy(() => import("./blocks/Embed"));
const MapContainer = lazy(() => import("./blocks/Map"));
const SearchHeroContainer = lazy(() => import("./blocks/SearchHero"));
const QuickLinks = lazy(() => import("./blocks/QuickLinks"));
const SummaryDisplayContainer = lazy(() => import("./blocks/SummaryDisplay"));
const KnowledgeCenterListingContainer = lazy(
  () => import("./blocks/KnowledgeCenterListing/index")
);
const IconLinksContainer = lazy(() => import("./blocks/IconLinks"));
const TestimonialsContainer = lazy(() => import("./blocks/Testimonials"));
const HighlightedSectionContainer = lazy(
  () => import("./blocks/HighlightedSection")
);
const AccentContainer = lazy(() => import("./blocks/Accent"));
const ResourcesContainer = lazy(() => import("./blocks/Resources"));
const NewsListingContainer = lazy(() => import("./blocks/NewsListing"));
const SimpleHeroContainer = lazy(() => import("./blocks/SimpleHero"));
const ValuesContainer = lazy(() => import("./blocks/Values"));
const AccordionsContainer = lazy(() => import("./blocks/Accordions"));
const LinkBarContainer = lazy(() => import("./blocks/LinkBar"));
const LinkDisplayContainer = lazy(() => import("./blocks/LinkDisplay"));
const StaffMembersContainer = lazy(() => import("./blocks/StaffMembers"));
const StackedDisplayContainer = lazy(() => import("./blocks/StackedDisplay"));
const TwoColumnRichTextContainer = lazy(
  () => import("./blocks/TwoColumnRichText")
);
const ComparisonTableContainer = lazy(() => import("./blocks/ComparisonTable"));
const PrintandShareContainer = lazy(
  () => import("./blocks/PrintandShare/index")
);

const Components = {
  kontent_item_dynamic_hero: DynamicHeroContainer,
  kontent_item_component___video_player: VideoPlayerContainer,
  kontent_item_formatted_rich_text: FormattedRichTextContainer,
  kontent_item_featured_media: FeaturedMediaContainer,
  kontent_item_cta_bar: CTABarContainer,
  kontent_item_embed: EmbedContainer,
  kontent_item_map: MapContainer,
  kontent_item_search_hero: SearchHeroContainer,
  kontent_item_quick_links: QuickLinks,
  kontent_item_summary_display: SummaryDisplayContainer,
  kontent_item_knowledge_center_listing: KnowledgeCenterListingContainer,
  kontent_item_icon_links: IconLinksContainer,
  kontent_item_testimonials: TestimonialsContainer,
  kontent_item_highlighted_section: HighlightedSectionContainer,
  kontent_item_accent: AccentContainer,
  kontent_item_resources: ResourcesContainer,
  kontent_item_news_listing: NewsListingContainer,
  kontent_item_simple_hero: SimpleHeroContainer,
  kontent_item_values: ValuesContainer,
  kontent_item_accordions: AccordionsContainer,
  kontent_item_link_bar: LinkBarContainer,
  kontent_item_link_display: LinkDisplayContainer,
  kontent_item_staff_members: StaffMembersContainer,
  kontent_item_stacked_display: StackedDisplayContainer,
  kontent_item_two_column_rich_text: TwoColumnRichTextContainer,
  kontent_item_comparison_table: ComparisonTableContainer,
  kontent_item_print_and_share: PrintandShareContainer,
};

const ReferenceComponent = ({
  name,
  ...props
}: {
  name: string;
  id: string;
  pageId: string;
}) => {
  //@ts-ignore
  let Component = Components[name];

  if (!Component) return null;

  return (
    <Suspense fallback={<LoadingTile />}>
      <Component {...props} />
    </Suspense>
  );
};

export default ReferenceComponent;
